module.exports = __webpack_public_path__ + "static/media/500Error.1a92828c.svg";